
import {useAuthenticator} from '@aws-amplify/ui-vue'
import {signInWithRedirect} from 'aws-amplify/auth'

export default {
  data() {
    const auth = useAuthenticator()
    return {
      auth, 
      loading: false,
      stage: 'email',
      formFields: {
        forgotPassword: {
          username: {
            label: 'Email',
            placeholder: 'Enter your email',
          },
        },
      }
      
    }
  },
  computed: {
    has_google() {
      const providers = JSON.parse(PROVIDERS).providers
      return providers.includes('Google')
    },
    error_text() {
      if (this.auth.error) {
        // errors caught by AmplifySDK
        return this.auth.error
      }

      // AmplifySDK doesn't catch lambda trigger errors, do it manually
      const search = window.location.search
      if (search.includes('error_description')) {
        try {
          const params = new URLSearchParams(search)
          const err_text = params.get('error_description')
          if (err_text) {
            return err_text
          }
        }
        catch(err) {
          console.warn(`Failed to parse query string ${search}:${err}`)
        }
      }

      return undefined
    }
  },
  watch: {
    'auth.isPending': function (val) {
      if (val === false) {
        this.stage = 'email'
      }
    },
    stage(val) {
      if (val === 'email') {
        this.$nextTick(() => {
          if (this.$refs.email) {
            this.$refs.email.value = ''
          }
        })
      }
    }
  },
  async mounted() {
    // Enable if SAML IDP-initated login support is requested
    // TODO: Should be changed when amply support for this login type is added.
    //       Refer https://github.com/aws-amplify/amplify-js/issues/13343
    // Example Azure RelayState URL for dev: 
    //       identity_provider=Genrate.AI&client_id=7p3oknno1r60i8t07op2mc4hli&response_type=code&scope=openid+email+profile&redirect_uri=http%3A%2F%2Flocalhost%3A8080%2Flogin%3Fidp_initiated%3Dtrue%26idp%3DGenrate.AI
    if (this.$route.query.idp_initiated?.toLowerCase() === 'true') {
      if (!this.$route.query.idp) throw Error('no idp in idp-initiated sign in')
      await signInWithRedirect({provider: {custom: this.$route.query.idp}})
    }
  },
  methods: {
    async signInCustom(provider) {
      await signInWithRedirect({provider: {custom: provider}})
    },
    async onEmailContinue() {
      if (!this.$refs.email.checkValidity()) {
        this.$refs.email.reportValidity()
        return
      }

      this.loading = true
      try {
        const domain = this.$refs.email.value.split('@')[1].toLowerCase()
        const realmProviders = JSON.parse(PROVIDERS)
        let provider = realmProviders.domain_providers[domain]
        if (!provider) {
          provider = 'COGNITO'
        }

        if (provider === 'COGNITO') {
          this.stage = 'password'
        } else {
          // Custom provider, redirect to IDP
          sessionStorage.setItem('current_idp', provider)
          await signInWithRedirect({provider: {custom: provider}})
        }
      }
      finally {
        this.loading = false
      }
    },
    onForgotPassword(amplifyForgot) {
      this.stage = 'email'
      amplifyForgot()
    }
  }
}
